// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1190":"e0b932aa","3202":"9f4a4789","8027":"aa5da65c"}[chunkId] + ".chunk.css";
};